import * as React from 'react';
import { PortalSubNavigation } from 'components/PortalStructure/PageParts/Portal/PortalSubNavigation';

interface IProps {
	className?: string;
	sideMenu: any;
	topMenu?: any;
}

class PortalTwoColumnLayout extends React.Component<IProps, {}> {
	private showDropdownMenu: boolean = false;
	private menuButtonElement: HTMLElement;

	constructor(props) {
		super(props);

		this.handleShowDropdownMenuClicked = this.handleShowDropdownMenuClicked.bind(this);
		this.handleClickOutsideDropdownMenu = this.handleClickOutsideDropdownMenu.bind(this);
	}

	public componentDidMount() {
		document.addEventListener('click', this.handleClickOutsideDropdownMenu, true);
	}

	public componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutsideDropdownMenu, true);
	}

	private handleClickOutsideDropdownMenu = (e) => {
		if (!this.menuButtonElement || !this.menuButtonElement.contains(e.target)) {
			if (this.showDropdownMenu) {
				this.handleShowDropdownMenuClicked();
			}
		}
	};

	private handleShowDropdownMenuClicked() {
		this.showDropdownMenu = !this.showDropdownMenu;
		this.forceUpdate();
	}

	public render() {
		return (
			<>
				<PortalSubNavigation topMenu={this.props.topMenu} />
				<div className={'container ' + (this.props.className || '') + ' ' + 'portalTwoColumnLayout'}>
					<div className="row">
						<div className="col-sm-3 col-md-2 col-12">{this.props.sideMenu}</div>
						<div className="col-sm-9 col-md-10 col-12">{this.props.children}</div>
					</div>
				</div>
			</>
		);
	}
}

export { PortalTwoColumnLayout };
